<template>
    <div class="dropdown">
        <div
            class="dropdown__selected"
            @click.stop="openDrop"
        >
            {{ activeItem }}
        </div>
        <transition name="fade">
            <div
                v-if="isOpen"
                class="dropdown__list"
            >
                <div
                    v-for="(item, index) in list"
                    :key="index"
                    class="dropdown__item"
                    @click="itemClick(item)"
                >
                    {{ item }}
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'LangDrop',
    components: {
    },
    props: {
        list: {
            type: [Array, Boolean],
            default: () => []
        },
        activeItemProp: {
            type: [Boolean, String],
            default: false
        }
    },
    emits: ['changeItem'],
    data () {
        return {
            activeItem: false,
            isOpen: false
        }
    },
    async mounted() {
        this.$forceUpdate()
        this.activeItem = this.activeItemProp || this.list[0]
        window.addEventListener('click', this.clickOutside)
    },
    beforeUnmount() {
        window.removeEventListener('click', this.clickOutside)
    },
    methods: {
        clickOutside(e) {
            if(!e.target.closest('.dropdown')) this.closeDrop()
        },
        closeDrop() {
            this.isOpen = false;
        },
        openDrop() {
            this.isOpen = true
        },
        itemClick(item) {
            if(!item) return
            this.activeItem = item;
            this.$emit('changeItem', this.activeItem)
            this.closeDrop()
        },
    }
}
</script>
<style scoped>
.dropdown {
    position: relative;
}
.dropdown__list {
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--white);
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.dropdown__selected,
.dropdown__item {
    font-size: 14px;
    font-weight: 600;
    color: var(--additional-dark-blue);
    height: 44px;
    width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.dropdown__item {
    color: var(--primary-blue);
    transition: .3s ease-in-out background-color;
}
.dropdown__item:hover {
    background-color: var(--muted-background);
}
@media only screen and (max-width: 768px) {
    .dropdown__selected,
    .dropdown__item {
        width: 50px;
    }
}
</style>
